import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { ServicePlace } from '../entities/service-place';

interface ApiResponse {
  status: string;
  data: ServicePlace[];
}

@Injectable({
  providedIn: 'root'
})
export class ServicePlaceService {

  constructor(private http: HttpClient) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private servicePlaceServiceUrl = this.apiServicesUrl + '/service-place';

  getServicePlaces(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.servicePlaceServiceUrl)
    .pipe(
      catchError(this.handleError<ApiResponse>('getServicePlaces'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
